import { useState, useEffect } from 'react';
import './style.scss';
import { Link, useNavigate, useLocation } from 'react-router-dom';

function Navigation() {
    const navigationItems = [
        { id: 'cover', label: 'FŐOLDAL', path: '/' },
        { id: 'about-us', label: 'RÓLUNK', path: '/about-us' },
        { id: 'services', label: 'SZAKRENDELÉSEINK', path: '#' },
        { id: 'prices', label: 'ÁRAINK', path: '/prices' },
        { id: 'contact', label: 'KAPCSOLAT', path: '/contact' },
        { id: 'carreer', label: 'KARRIER', path: '/carreer' },
    ];

    const [isOpened, setIsOpened] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);  // Követjük az ablak méretét
    const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth);  // Figyeljük a tájolást

    const navigate = useNavigate();
    const location = useLocation();

    const onNavigationToggle = () => {
        setIsOpened(!isOpened);
    };

    const updateScrollState = () => {
        const isMobileOrTablet = window.innerWidth <= 1024;
        const isMobile = window.innerWidth <= 780;
        const isAboutUs = location.pathname === '/about-us';
        const isContact = location.pathname === '/contact';
        const isLandscapeTablet = window.innerWidth > 1024 && window.innerWidth <= 1380 && window.innerHeight < window.innerWidth;

        const scrolled = 
            (window.scrollY > 50) ||
            (!isAboutUs && location.pathname !== '/' && !isContact) ||
            ((isAboutUs || isContact) && isOpened && isMobileOrTablet) ||
            (isOpened && isMobile) ||
            (isOpened && isLandscapeTablet); 

        setIsScrolled(scrolled);
    };


    // Figyeljük a képernyőméret és tájolás változását
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            setIsPortrait(window.innerHeight > window.innerWidth); // Frissítjük a tájolást

            if (window.innerWidth > 1024 || window.innerWidth < 800) {  // Ha nagyobb mint 1024px vagy kisebb mint 800px
                setIsOpened(false);  // Bezárjuk a menüt
            }
        };

        window.addEventListener('resize', handleResize);  // A képernyőméret változását figyeljük

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        updateScrollState();
        window.addEventListener('scroll', updateScrollState);

        return () => {
            window.removeEventListener('scroll', updateScrollState);
        };
    }, [location.pathname, isOpened]);

    const scrollToContentCircles = () => {
        const element = document.getElementById('contentcircles');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    let scrollToCover = () => {
        document.getElementById("cover").scrollIntoView({behavior:'smooth'});
    }

    const handleClick = (id, path) => { 
        setIsOpened(false);  // Bezárjuk a menüt
    
        if (id === 'services') {
            if (location.pathname !== '/') {
                navigate('/'); 
                setTimeout(() => {
                    scrollToContentCircles();
                }, 500);
            } else {
                scrollToContentCircles();
            }
        } else if (id === 'cover') {
            if (location.pathname !== '/') {
                navigate('/'); 
                setTimeout(() => {
                    scrollToCover();
                }, 500);
            } else {
                scrollToCover();
            }
        } else {
            navigate(path);  // Másik oldalra navigálunk
            setIsOpened(false);  
        }
    };


    return (
        <nav className={`main-navigation ${isScrolled ? 'scrolled' : ''}`}>
            <Link to='/'>
                <div className='main-navigation-img'>
                    <img src='/img/vbeklogo.png' height={55} width={140} alt='vbek logo' />
                </div>
            </Link>
            <ul className='main-navigation-links' style={{ display: isOpened && windowWidth <= 1380 ? 'flex' : 'none' }}>
                {navigationItems.map((navigationItem) => (
                    <li key={navigationItem.id} className='navigation-link-buttons'>
                        <Link 
                            to={navigationItem.path}
                            onClick={(e) => {
                                e.preventDefault();
                                handleClick(navigationItem.id, navigationItem.path);
                            }} 
                            className={`navigation-link-buttons ${isScrolled ? 'scrolled' : ''}`}
                        >
                            {navigationItem.label}
                        </Link>
                    </li>
                ))}
            </ul>
            <button className={`mobile-toggler ${isOpened ? 'open' : ''}`} onClick={onNavigationToggle}>
                <span className="line line-1"></span>
                <span className="line line-2"></span>
                <span className="line line-3"></span>
            </button>
        </nav>
    );
}

export default Navigation;
